<template lang="html">
  <v-content>
    <v-dialog
      v-model="uploadedDocumentsDialogOpened"
      max-width="1000"
      :fullscreen="$vuetify.breakpoint.xsOnly"
      @keydown.esc="uploadedDocumentsDialogOpened = false"
    >
      <v-card>
        <v-card-title class="title">
          Documents uploaded {{ selectedFilter }}
          <v-spacer />
          <v-btn
            small
            flat
            fab
            class="my-0 white error--text text-capitalize"
            @click="uploadedDocumentsDialogOpened = false"
          >
            <v-icon size="24"> clear </v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <document-table :documents="uploadedDocumentLogs" />
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="remindersDialogOpened"
      max-width="1000"
      :fullscreen="$vuetify.breakpoint.xsOnly"
      @keydown.esc="remindersDialogOpened = false"
    >
      <v-card>
        <v-card-title class="title pt-4">
          Reminders sent {{ selectedFilter }}
          <v-spacer />
          <v-btn
            small
            flat
            fab
            class="my-0 white error--text text-capitalize"
            @click="remindersDialogOpened = false"
          >
            <v-icon size="24"> clear </v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <reminder-table :reminders="reminderLogs" />
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="unrepliedMessagesDialogOpened"
      max-width="1000"
      :fullscreen="$vuetify.breakpoint.xsOnly"
      @keydown.esc="unrepliedMessagesDialogOpened = false"
    >
      <v-card>
        <v-card-title class="title pt-4">
          Unreplied messages from {{ selectedFilter }}
          <v-spacer />
          <v-btn
            small
            flat
            fab
            class="my-0 white error--text text-capitalize"
            @click="unrepliedMessagesDialogOpened = false"
          >
            <v-icon size="24"> clear </v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <message-table
            :messages="unrepliedMessages"
            @openSpecificConversation="openSpecificConversation"
          />
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="notificationsDialogOpened"
      max-width="1000"
      :fullscreen="$vuetify.breakpoint.xsOnly"
      @keydown.esc="notificationsDialogOpened = false"
    >
      <v-card>
        <v-card-title class="title pt-4">
          Notifications from {{ selectedFilter }}
          <v-spacer />
          <v-btn
            small
            flat
            fab
            class="my-0 white error--text text-capitalize"
            @click="notificationsDialogOpened = false"
          >
            <v-icon size="24"> clear </v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <notification-table
            :notifications="notifications"
            @handleNotification="handleNotification"
          />
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="questionnairesDialog"
      max-width="1000"
      :fullscreen="$vuetify.breakpoint.xsOnly"
      @keydown.esc="questionnairesDialog = false"
    >
      <v-card>
        <v-card-title class="title pt-4">
          {{
            showUpdatedQuestionnaires
              ? 'Updated questionnaires'
              : 'Questionnaires started'
          }}
          from {{ selectedFilter }}
          <v-spacer />
          <v-btn
            small
            flat
            fab
            class="my-0 white error--text text-capitalize"
            @click="questionnairesDialog = false"
          >
            <v-icon size="24"> clear </v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <questionnaires-table
            :questionnaires="
              showUpdatedQuestionnaires
                ? updatedQuestionnaires
                : startedQuestionnaires
            "
          />
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-container>
      <v-layout class="mb-2" align-center>
        <soraban-action-button
          @click="$router.go(-1)"
          icon="keyboard_arrow_left"
          help="Back"
          v-if="$vuetify.breakpoint.smAndUp"
        />
        <h1>Activity Summary</h1>
        <v-spacer />
      </v-layout>
      <v-layout class="ml-2 mb-4">
        <v-flex xs6 class="text-xs-left">
          <v-btn-toggle v-model="selectedFilter">
            <v-btn flat :value="'yesterday'" class="text-capitalize">
              Yesterday
            </v-btn>
            <v-btn flat :value="'today'" class="text-capitalize"> Today </v-btn>
            <v-btn flat :value="'this week'" class="text-capitalize">
              This week
            </v-btn>
          </v-btn-toggle>
        </v-flex>
        <v-flex xs6 class="alert-wrapper">
          <span v-if="lastUpdatedDuration"
            >Last updated {{ lastUpdatedDuration }}</span
          >
          <v-tooltip bottom>
            <v-icon
              slot="activator"
              class="ml-1"
              size="18"
              @click.prevent.stop="getAllLogs()"
              >refresh</v-icon
            >
            <span>Refresh</span>
          </v-tooltip>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs6>
          <SummaryCard
            :count="
              uploadedDocumentLogs != null ? uploadedDocumentLogs.length : null
            "
            @view-all="uploadedDocumentsDialogOpened = true"
          >
            Documents Uploaded
          </SummaryCard>
        </v-flex>
        <v-flex xs6>
          <SummaryCard
            :count="reminderLogs != null ? reminderLogs.length : null"
            @view-all="remindersDialogOpened = true"
          >
            Reminders Sent
          </SummaryCard>
        </v-flex>
      </v-layout>
      <v-layout>
        <!-- <v-flex xs6>
          <SummaryCard
            :count='unrepliedMessages != null ? unrepliedMessages.length : null'
            @viewAll="handleViewAllUnrepliedMessages"
          >
            clients waiting for replies
          </SummaryCard>
        </v-flex> -->
        <!-- <v-flex xs6>
          <SummaryCard
            :count='notifications != null ? notifications.length : null'
            @viewAll="handleViewAllNotifications"
          >
            notifications
          </SummaryCard>
        </v-flex> -->
      </v-layout>
      <v-layout>
        <v-flex xs6>
          <SummaryCard
            :count="updatedQuestionnairesCount"
            @view-all="
              questionnairesDialog = true;
              showUpdatedQuestionnaires = true;
            "
          >
            Updated Questionnaires
          </SummaryCard>
        </v-flex>
        <v-flex xs6>
          <SummaryCard
            :count="startedQuestionnairesCount"
            @view-all="
              questionnairesDialog = true;
              showUpdatedQuestionnaires = false;
            "
          >
            Questionnaires Started
          </SummaryCard>
        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
import moment from 'moment';
import SummaryCard from './components/SummaryCard';
import DocumentTable from '@/components/tables/DocumentTable';
import ReminderTable from '@/components/tables/ReminderTable';
import MessageTable from '@/components/tables/MessageTable';
import NotificationTable from '@/components/tables/NotificationTable';
import QuestionnairesTable from '@/components/tables/QuestionnairesTable';
import API from '@/api';

export default {
  name: 'ActivitySummary',
  components: {
    SummaryCard,
    DocumentTable,
    ReminderTable,
    MessageTable,
    NotificationTable,
    QuestionnairesTable,
  },
  data() {
    return {
      questionnairesDialog: false,
      showUpdatedQuestionnaires: false,
      selectedFilter: 'yesterday',
      uploadedDocumentsDialogOpened: false,
      remindersDialogOpened: false,
      unrepliedMessagesDialogOpened: false,
      notificationsDialogOpened: false,
      uploadedDocumentLogs: null,
      reminderLogs: null,
      updatedQuestionnaires: null,
      startedQuestionnaires: null,
      unrepliedMessages: null,
      notifications: null,
      lastUpdateTime: null,
      lastUpdatedDuration: null,
      updateInterval: null,
    };
  },
  computed: {
    updatedQuestionnairesCount() {
      return this.updatedQuestionnaires != null
        ? this.updatedQuestionnaires.length
        : null;
    },
    startedQuestionnairesCount() {
      return this.startedQuestionnaires != null
        ? this.startedQuestionnaires.length
        : null;
    },
  },
  methods: {
    openSpecificConversation(conversationId) {
      this.$emit('openSpecificConversation', conversationId);
    },
    handleNotification(notification, openInNewWindow) {
      this.$emit('handleNotification', notification, openInNewWindow);
    },
    resetLogs() {
      this.uploadedDocumentLogs = null;
      this.reminderLogs = null;
      this.updatedQuestionnaires = null;
      this.unrepliedMessages = null;
      this.notifications = null;
    },
    getAllLogs() {
      this.resetLogs();
      this.getUploadedDocumentLogs();
      this.getReminderLogs();
      this.getUpdatedQuestionnaires();
      this.getStartedQuestionnaires();

      this.lastUpdateTime = moment();
      this.updateTime();
    },
    async getUploadedDocumentLogs() {
      const response = await API.advisor.getUploadedDocumentLogs({
        timeRange: this.selectedFilter,
      });
      this.uploadedDocumentLogs = response.data.logs;
    },
    async getReminderLogs() {
      const response = await API.advisor.getReminderLogs({
        timeRange: this.selectedFilter,
      });
      this.reminderLogs = response.data.logs;
    },
    async getUpdatedQuestionnaires() {
      const response = await API.advisor.getUpdatedQuestionnaires({
        timeRange: this.selectedFilter,
      });
      this.updatedQuestionnaires = response.data.questionnaires;
    },
    async getStartedQuestionnaires() {
      const response = await API.advisor.getStartedQuestionnaires({
        timeRange: this.selectedFilter,
      });
      this.startedQuestionnaires = response.data.questionnaires;
    },
    updateTime() {
      if (this.lastUpdateTime) {
        this.lastUpdatedDuration = this.lastUpdateTime.fromNow();
      }
    },
  },
  watch: {
    selectedFilter: {
      async handler() {
        await this.getAllLogs();
      },
    },
  },
  async created() {
    await this.getAllLogs();
    this.updateInterval = setInterval(() => {
      this.updateTime();
    }, 60000);
  },
  destroyed() {
    if (this.updateInterval) {
      clearInterval(this.updateInterval);
    }
  },
};
</script>

<style lang="postcss" scoped>
.title {
  font-weight: 700;
}
.alert-wrapper {
  align-items: center;
  display: flex;
  justify-content: end;
  padding-right: 10px;
}
</style>
